import { useState } from "react";
import { navLinks, lastUpdated } from "@/mocks/home";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2 text-xs">
          <span className="inline-flex items-center gap-1.5">
            <span className="h-2 w-2 animate-slow-pulse rounded-full bg-primary-400"></span>
            线路实时巡检中
          </span>
          <span className="hidden text-foreground-700 sm:inline">|</span>
          <span className="text-background-200">
            最近更新：{lastUpdated.date} {lastUpdated.time}
          </span>
          <span className="hidden text-foreground-700 sm:inline">|</span>
          <span className="hidden text-background-300 sm:inline">
            {lastUpdated.note}
          </span>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-content items-center justify-between px-4 py-3">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">
              星辰影院
            </span>
          </a>

          <nav className="hidden items-center gap-7 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <a
            href="#entry"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-link"></i>
            获取最新入口
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>

        {open ? (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <nav className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between border-b border-background-100 py-3 text-sm text-foreground-800"
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </a>
              ))}
            </nav>
            <a
              href="#entry"
              onClick={() => setOpen(false)}
              className="mt-4 flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-link"></i>
              获取最新入口
            </a>
          </div>
        ) : null}
      </div>
    </header>
  );
}